module.exports = __webpack_public_path__ + "img/three2Red.e0dcd3ae.jpg";